// src/components/LocationIntervalModal.js (adjust path as needed)
import React, { useState, useEffect } from "react";
import ModalForm from "../delivery/ModalForm"; // Ensure this path is correct
import SettingsServices from "../../services/SettingsServices";
import { useDispatch, useSelector } from "react-redux";
import { setShowMessage } from "../../redux/slices/notificationSlice";
import translations from "../../assets/locals/translations";

const LocationIntervalModal = ({ showModal, setShowLocationIntervalModal }) => {
  const settings = new SettingsServices();
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations["en"];
  const [selectedInterval, setSelectedInterval] = useState(5);

  // Hardcoded strings
  const modalTitle = t.locationupdateinterval || "Location Update Interval";
  const description =
    t.selectfrequently ||
    "Select how frequently the employee's location should be updated.";
  const saveButtonText = t.submit || "Save";
  const closeButtonText = t.close || "Close";
  const updateIntervalLabelText = t.updateinterval || "Update Interval";

  const intervalOptions = [
    { value: 5, label: t.fiveminutes || "5 Minutes" },
    { value: 10, label: t.tenminutes || "10 Minutes" },
    { value: 15, label: t.fifteenminutes || "15 Minutes" },
    { value: 30, label: t.thirtyseconds || "30 Minutes" },
    { value: 60, label: t.onehour || "1 Hour" },
  ];

  const [isTrackingEnabled, setIsTrackingEnabled] = useState(false);
  const [tracking, setTracking] = useState({
    enabledTracking: false,
    trackingInterval: 5,
  });

  const handleCloseModal = () => {
    setShowLocationIntervalModal(false);
  };

  const getUserTracking = async () => {
    try {
      const response = await settings.getUserTracking();
      if (response && response.isSuccess) {
        setTracking(response.tracking);
        setIsTrackingEnabled(response.tracking.enabledTracking);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getUserTracking();
  }, []);

  const handleInterval = async () => {
    try {
      const response = await settings.userTracking({
        status: tracking.enabledTracking,
        interval: selectedInterval,
      });
      if (response && response.isSuccess) {
        dispatch(setShowMessage(response.message));
        setShowLocationIntervalModal(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <ModalForm isOpen={showModal} onClose={handleCloseModal} title={modalTitle}>
      {/* Children start here */}
      <p>{description}</p>
      <div
        className="interval-select-container"
        style={{ marginTop: "15px", marginBottom: "15px" }}
      >
        <label
          htmlFor="interval-select-refactored"
          style={{ marginRight: "10px", display: "block", marginBottom: "5px" }}
        >
          {updateIntervalLabelText}
        </label>
        <select
          id="interval-select-refactored"
          value={selectedInterval}
          onChange={(e) => setSelectedInterval(parseInt(e.target.value, 10))}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            boxSizing: "border-box",
          }}
        >
          {intervalOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="border-top pt-3 d-flex justify-content-end align-items-end mt-3">
        <button onClick={handleInterval} className="btn btn-secondary">
          {saveButtonText}
        </button>
        <button onClick={handleCloseModal} className="btn btn-secondary ms-2">
          {closeButtonText}
        </button>
      </div>
      {/* Children end here */}
    </ModalForm>
  );
};

export default LocationIntervalModal;
